// extracted by mini-css-extract-plugin
export default {"botaoDica":"BotaoDica_botaoDica__-SePd","btn":"BotaoDica_btn__StvxS","btnDisabled":"BotaoDica_btnDisabled__VWFsR"};